import React from 'react'
import { type ProviderConfig, LDProvider } from 'launchdarkly-react-client-sdk'
import { LDContextCommon } from 'launchdarkly-js-sdk-common'
import { useIdentity } from '@equipmentshare/auth0-react'

export type LDContextWithKeyType = {
     readonly key: string;
} & LDContextCommon;

export type LaunchDarklyProviderPropsType = {
    readonly children: React.ReactNode;
    readonly clientId: ProviderConfig['clientSideID'];
};

export const LaunchDarkly = ( {
	children,
	clientId,
}: LaunchDarklyProviderPropsType ) => {
	const identity = useIdentity()

	return (
		<LDProvider
			clientSideID={clientId}
			context={ {
				kind: 'multi',
				user: {
					key: String( identity.userId ),
					name: identity.fullName,
					email: identity.email,
					companyId: identity.companyId,
					...( identity.identityId && { identityId: identity.identityId } ),
				},
			}}
		>
			{children}
		</LDProvider>
	)
}
